<div class="basicrow">
    <div class="container">
        <div class="fulltitle m-top-i f-btitle" (click)="this.ocultarPreguntasFrecuentes()" style="cursor: pointer;">
            <img src="../../../assets/images/ico_preguntasFrecuentes.png" style="height: 90px;"> Preguntas Frecuentes
            <a (click)="this.ocultarPreguntasFrecuentes()" class="btns blue refdef refdefright vcenter a">
                Regresar
            </a>
        </div>
    </div>
    <app-referred-faq-collapse [(content)]="this.content"></app-referred-faq-collapse>
    <div (click)="this.ocultarPreguntasFrecuentes()" class="basicrow m-top"
        style="text-align: center;align-content: center;align-items: center;">
        <a 
            class="btns blue refdef refdefright vcenter b">
            Regresar
        </a>
    </div>
</div>